import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@/assets/icons/LibrarySvg';
import { tileButton } from '@/components/Board/commonToolbarStyles';
import Tooltip from '@/components/Common/Tooltip';
/**
 * Компонент для кнопки блокировки/разблокировки выделения
 */
export const LockButton = ({ selectionLocked, onToggleLock }) => {
    const isLocked = selectionLocked !== null && selectionLocked !== void 0 ? selectionLocked : false;
    return (_jsx("div", { className: "lock-unlock-container", children: _jsx(Tooltip, { text: isLocked ? 'Разблокировать элемент' : 'Заблокировать элемент', position: "top", children: _jsx("button", { type: "button", onClick: () => onToggleLock(!isLocked), disabled: selectionLocked === null, style: tileButton(isLocked, { padding: '8px 14px' }), "aria-pressed": isLocked, "aria-label": isLocked ? 'Разблокировать элемент' : 'Заблокировать элемент', tabIndex: 0, children: _jsx(Icon, { name: selectionLocked ? 'lock_1' : 'lock_1' }) }) }) }));
};
